import DiscoverIconSM from "@/components/DiscoverIconSm";
import { Card, Center, Container, Text, useColorMode } from "@chakra-ui/react";
import Head from "next/head";
import Link from "next/link";

const data = [
  { title: "Discover", link: "/" },
  { title: "What is a songcard?", link: "/info" },
  {
    title: "Artist Portal",
    link: "https://artists.songcards.io/",

    external: true,
  },
  { title: "Account", link: "/account" },
  { title: "Blog", link: "/blog" },
  { title: "Card Of The Day", link: "/cotd" },
  {
    title: "Get App",
    link: "/get-app",
    external: false,
  },
  {
    title: "Interview w/ Hypebot",
    link: "https://www.hypebot.com/hypebot/2025/12/chris-carvalho-of-songcards-on-building-fan-value-into-digital-music-releases.html",
    external: true,
  },
  {
    title: "Interview w/ Soundworks",
    link: "https://soundworks.substack.com/p/inside-songcards-a-creative-take",
    external: true,
  },
  {
    title: "Collector's Club",
    link: "https://songcards.substack.com/embed",
    external: true,
  },
  { title: "Discord", link: "https://discord.gg/ZqyaGf4EPc" },
  {
    title: "Support",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfelEQmiE8Yr589pqjhEDeGJXyqGwuYZ-ROTlTy_b6mw5ErqA/viewform?usp=sf_link",
    external: true,
  },
  { title: "Contact", link: "mailto:chris@songcards.io" },
];

// https://songcards.substack.com/embed

export default function LinkPage() {
  const { colorMode } = useColorMode();

  return (
    <>
      <Head>
        <title>Links | Songcards</title>
        <meta property="og:site_name" content="Songcards" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href="https://songcards.io/links" />
        <meta name="description" content="Listen. Discover. Collect." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" href="/icon.png" />
        <link rel="icon" href="/songcards.png" />

        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/links" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Songcards" />
        <meta property="og:title" content="Links | Songcards" />
        <meta property="og:description" content="Listen. Discover. Collect." />
        <meta name="twitter:domain" content="songcards.io" />
        <meta name="twitter:site" content="@unlockyoursound" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Links | Songcards" />
        <meta name="twitter:description" content="Listen. Discover. Collect." />

        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <meta name="apple-itunes-app" content="app-id=6737206374" />
      </Head>
      {data.map((link, index) => (
        <Center key={index}>
          <Link href={link.link} target={link.external ? "_blank" : undefined}>
            <Card
              maxW="xs"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgColor={colorMode === "dark" ? "black" : "white"}
              variant="outline"
              borderColor={colorMode === "dark" ? "white" : "black"}
              borderStyle="dotted"
              borderRadius={20}
              height="50px"
              width="300px"
              textAlign="center"
            >
              <Text>{link.title}</Text>
            </Card>
          </Link>
          <br />
          <br />
          <br />
        </Center>
      ))}
      <DiscoverIconSM />
      <Container mb={200}>
        <></>
      </Container>
    </>
  );
}
